<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
    <template #ROLEAUTH="{visible,params}">
      <Auth :row="params" v-if="visible" ref="childTree" />
    </template>
  </cTable>
</template>

<script>
import {
  add,
  getUser,
  getDetails,
  update,
  del,
  updatePwd,
  exportFreight,
  saveBatchStatus,
  getAllRoles
} from "@/api/user/internal";
import { getWarehouse } from "@/api/storage/warehouse";
import { getDepartment } from "@/api/system/department";
import { getRole, saveRoleAuth } from "@/api/system/role";
import { getRoleMapping } from "@/api/user/role_map";
import cTable from "@/base/common/index";
import Auth from "@/view/auth/role/auth";
import { getCompanies } from "@/api/user/client";
import { cancelAgentOff } from "@/api/finance/codList";

export default {
  name: "internal",
  components: {
    cTable,
    Auth
  },
  mounted() {
    this.header.searchs.forEach(async item => {
      if (item.key === "standard")
        item.options = (await getRoleMapping()).data.payload.rows;
      if (item.key === "ownership")
        item.options = (await getCompanies()).data.payload;
    });
  },
  data() {
    return {
      methods: {
        list: getUser,
        add,
        getDetails,
        update,
        del,
        updatePwd,
        getWarehouse,
        getDepartment,
        getRole,
        getRoleMapping,
        saveRoleAuth,
        getCompanies,
        saveBatchStatus,
        getAllRoles
      },
      config: {
        height: 630
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page
                .handleRequestMethods(row.id ? "update" : "add", data)
                .then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  this.$page.getList();
                  close();
                });
            }
          },
          // footer: {
          //   show: () => false
          // },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              maskClosable: false
            },
            title: this.$t("add"),
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              account: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              password: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              realname: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              ownership: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ]
            }
          },
          grid: [
            { account: 24 },
            { password: 24 },
            { realname: 24 },
            { ownership: 24 },
            // { job_number: 24 },
            { warehouse_id: 24 },
            { role_id: 24 },
            { department_id: 24 },
            { status: 24 }
          ],
          fields: [
            {
              key: "account",
              name: () => this.$t("account"),
              component: "Input",
							disabled({row}){
								return !!row.id
							},
              placeholder() {
                return this.$t("enter") + this.$t("account");
              }
            },
            {
              key: "password",
              name: () => this.$t("password"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("password");
              },
              bind: {
                type: "password",
                password: true
              },
              show({ row }) {
                return row.id ? false : true;
              }
            },
            {
              key: "realname",
              name: () => this.$t("realname"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("realname");
              }
            },
            {
              key: "phone",
              name: () => this.$t("phone"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("phone");
              }
            },
            {
              key: "job_number",
              name: () => this.$t("job_number"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("job_number");
              }
            },
            {
              key: "warehouse_id",
              name: () => this.$t("warehouseName"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("warehouseName");
              },
              options: [],
              config: {
                label: "title",
                value: "id"
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getWarehouse")
                  ).payload.rows;
                  this.$forceUpdate();
                }
              }
            },
            {
              key: "role_id",
              name: () => this.$t("bindRole"),
              component: "Select",
              config: {
                label: "title",
                value: "id"
              },
              placeholder() {
                return this.$t("select") + this.$t("bindRole");
              },
              options: [],
              trees: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getAllRoles")
                  ).payload;
                  // console.log(trees);
                  // this.handleTree({ field, trees });
                  this.$forceUpdate();
                }
              },
              default: [],
              bind: {
                style: {
                  width: "100%"
                },
                multiple: true,
                "max-tag-count": 3
              }
            },
            {
              key: "department_id",
              name: () => this.$t("deName"),
              component: "SelectTree",
              config: {
                label: "title",
                value: "id"
              },
              placeholder() {
                return this.$t("select") + this.$t("deName");
              },
              options: [],
              trees: [],
              methods: {
                async list({ field }) {
                  let trees = (
                    await this.$page.handleRequestMethods("getDepartment")
                  ).payload.rows;
                  this.handleTree({ field, trees });
                  this.$forceUpdate();
                }
              }
            },
            {
              key: "ownership",
              name: () => this.$t("ownership"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("ownership");
              },
              options: [],
              config: {
                label: "title",
                value: "id"
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCompanies")
                  ).payload;
                  this.$forceUpdate();
                }
              }
            },
            {
              key: "status",
              name: () => this.$t("CurrentState"),
              component: "Radio",
              options: [
                {
                  label: this.$t("enable"),
                  value: "ENABLE"
                },
                {
                  label: this.$t("disable"),
                  value: "DISABLE"
                }
              ],
              bind: {
                border: true
              },
              show({ row }) {
                return row.id ? true : false;
              }
            }
          ]
        },
        statusModal: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.id = this.$page.selectAll.map(item => item.id);
              this.$page
                .handleRequestMethods("saveBatchStatus", data)
                .then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              maskClosable: false
            },
            title:
              this.$t("batch") + this.$t("enable") + "/" + this.$t("disable"),
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              status: [
                {
                  required: true,
                  trigger: "change"
                }
              ]
            }
          },
          grid: [{ status: 24 }],
          fields: [
            {
              key: "status",
              name: () => this.$t("enable") + "/" + this.$t("disable"),
              component: "Radio",
              options: [
                {
                  label: this.$t("enable"),
                  value: "ENABLE"
                },
                {
                  label: this.$t("disable"),
                  value: "DISABLE"
                }
              ],
              bind: {
                border: true
              }
            }
          ]
        },
        updatePwd: {
          methods: {
            ok({ row, close }) {
              delete row.confirmPwd;
              delete row.account;
              this.$page.handleRequestMethods("updatePwd", {
                ...row,
                type: 'simple'
              }).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              maskClosable: false
            },
            title: this.$t("updatePwd"),

            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              hash_password: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              confirmPwd: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                },
                {
                  validator: function(rule, value, callback) {
                    if (value != this.formData.hash_password) {
                      return callback(new Error(this.$t("Thetwopasswords")));
                    }
                    callback();
                  },
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ account: 24 }, { hash_password: 24 }, { confirmPwd: 24 }],
          fields: [
            {
              key: "account",
              name: () => this.$t("account"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("account");
              },
              disabled: true
            },
            {
              key: "hash_password",
              name: () => this.$t("password"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("password");
              },
              bind: {
                type: "password",
                password: true
              },
              methods: {
                "on-change"({ formData }) {
                  formData.confirmPwd = "";
                }
              }
            },
            {
              key: "confirmPwd",
              name: () => this.$t("password"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("password");
              },
              bind: {
                type: "password",
                password: true
              }
            }
          ]
        },
        roleAuth: {
          methods: {
            ok: ({ row, close }) => {
              let data = {
                role_id: row.id,
                rules: this.$refs["childTree"].handClick().map(item => item.id)
              };
              this.$refs["table"]
                .handleRequestMethods("saveRoleAuth", data)
                .then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  this.$refs["table"].getList();
                  close();
                });
            }
          },
          contentSlot: "ROLEAUTH",
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            title: this.$t("roleAuth")
          },
          footer: {
            show: () => true
          }
        }
      },
      header: {
        config: {
          custom: false
        },
        searchs: [
          {
            key: "standard",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("roleName");
            },
            options: [],
            config: { label: "name", value: "code" }
          },
          {
            key: "ownership",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            options: [],
            config: { label: "title", value: "id" }
          },
          {
            key: "status",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("type");
            },
            options: [
              { label: this.$t("enable"), value: "ENABLE" },
              { label: this.$t("disable"), value: "DISABLE" }
            ]
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                type: "warning",
                icon: "md-add"
              },
              id: 108
            },
            {
              name: () =>
                this.$t("batch") + this.$t("enable") + this.$t("disable"),
              type: "openStatusModal",
              fnName: "openStatusModal",
              bind: {
                type: "primary"
              },
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () => this.$t("export"),
              btnBind: {
                icon: "md-arrow-down",
                type: "primary"
              },

              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open();
            },
            openStatusModal() {
              this.getModal("statusModal").open();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("userName"),
          key: "account",
          minWidth: 110,
          align: "left"
        },
        {
          name: () => this.$t("CurrentState"),
          key: "status_name",
          minWidth: 80,
          render: (h, { row }) => {
            return h(
              "div",
              {
                style: {
                  color: row.status == "ENABLE" ? "#4caf50" : "#f44336"
                }
              },
              row.status_name
            );
          }
        },
        {
          name: () =>
            this.$t("enable") + "/" + this.$t("disable") + this.$t("time"),
          key: "status_time",
          width: 150
        },
        {
          name: () => this.$t("createUser"),
          key: "createUser",
          minWidth: 100,
          methods: {
            render({ value }) {
              return value && value.account;
            }
          }
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 150
        },
        {
          name: () => this.$t("login") + this.$t("time"),
          key: "login_time",
          width: 150
        },
        {
          name: () => this.$t("countryCode"),
          key: "country_code",
          width: 80
        },
        {
          name: () => this.$t("warehouseName"),
          key: "warehouse",
          width: 110,
          align: "left",
          methods: {
            render({ value }) {
              return value && value.title;
            }
          }
        },
        {
          name: () => this.$t("bindRole"),
          key: "roles",
          minWidth: 140,
          align: "left",
          showOverflow: false,
          render: (h, { row }) => {
            if (row.roles.length) {
              let data = row.roles;
              return h("div", [
                data.map((item, index) => {
                  return h(
                    "Button",
                    {
                      props: {
                        type: index % 2 == 0 ? "info" : "success",
                        size: "small",
                        disabled:
                          item.role_id == 5 || row.status == "DISABLE" || !item
                      },
                      style: {
                        marginRight: "5px",
                        marginBottom: "5px",
                        float: "left"
                      },
                      on: {
                        click: () => {
                          // this.$hasPermission(1319) && this.$refs["table"].getModal("roleAuth").open(item);
                        }
                      }
                    },
                    item.title
                  );
                })
              ]);
            }
          }
        },
        {
          name: () => this.$t("bindDep"),
          key: "department",
          minWidth: 80,
          align: "left",
          methods: {
            render({ value }) {
              return value && value.title;
            }
          }
        },
        {
          name: () => this.$t("countryTimezone"),
          key: "timezone",
          minWidth: 110,
          align: "left"
        },
        {
          name: () => this.$t("realname"),
          key: "realname",
          minWidth: 110,
          align: "left"
        },
        {
          name: () => this.$t("phone"),
          key: "phone",
          minWidth: 80
        },
        {
          name: () => this.$t("ownership"),
          key: "ownership_name",
          minWidth: 80
        },
        // {
        //   name: () => this.$t("avatar"),
        //   key: "avatar",
        //   minWidth: 80
        // },
        {
          type: "btns",
          width: 260,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("export") + this.$t("bindFreight"),
              type: "export",
              fnName: "export",
              bind: {
                type: "error"
              },
							id:1359,
            },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 109
            },
            {
              name: () => this.$t("updatePwd"),
              type: "updatePwd",
              fnName: "updatePwd",
              bind: {
                type: "info"
              },
              id: 111
            }
            // {
            //   name: () => this.$t("delete"),
            //   type: "delete",
            //   fnName: "delete"
            // }
          ],
          methods: {
            export({ row }) {
              this.openLoading();
              exportFreight(row.id).then(res => {
                this.$Message[res.data.status ? "success" : "error"]({
                  background: true,
                  content: res.data.msg
                });
                if (res.data.status) {
                  window.open(this.$globalUrl + res.data.payload);
                }
                this.closeLoading();
              });
            },
            async update({ row }) {
              let res = (await this.handleRequestMethods("getDetails", row.id))
                .payload;
              res.role_id = row.roles.map(item => item.role_id);
              this.getModal("add").open(res, function() {
                this.setTitle(this.$t("update"));
              });
            },
            updatePwd({ row }) {
              let data = {
                account: row.account,
                id: row.id,
                confirmPwd: "",
                hash_password: ""
              };
              this.getModal("updatePwd").open(data);
            }
            // delete({ row }) {
            //   this.$Modal.confirm({
            //     title: this.$t("delete"),
            //     width: 300,
            //     content: this.$t("titleModal"),
            //     onOk: () => {
            //       this.handleRequestMethods("del", row.airway_number).then(
            //         res => {
            //           this.$Message["success"]({
            //             background: true,
            //             content: res.msg
            //           });
            //           this.getList();
            //         }
            //       );
            //     }
            //   });
            // }
          }
        }
      ]
    };
  }
};
</script>
<style>
.header-title {
  display: flex;
  height: 40px;
  align-items: center;
}
</style>
